<template>
  <a-form autocomplete="off" :form="form.fc" @submit="handleSubmit">
    <a-form-item>
      <a-input size="large" v-decorator="decorator.mobile" :placeholder="$t('scope.text_323')" addonBefore="+86">
        <a-icon slot="prefix" type="phone" style="color: rgba(0, 0, 0, .25)" />
      </a-input>
    </a-form-item>
    <a-form-item>
      <a-input-group size="large">
        <a-row :gutter="8">
          <a-col :span="18">
            <a-input v-decorator="decorator.random_code" :placeholder="$t('scope.text_324')" />
          </a-col>
          <a-col :span="6">
            <a-button size="large" :disabled="enableSendSmsCode" @click="getWebSmsCode" style="width: 100%">{{ enableSendSmsCode && startCountDown ? $t('scope.text_325', [count]) : $t('scope.text_326') }}</a-button>
          </a-col>
        </a-row>
      </a-input-group>
    </a-form-item>
    <a-form-item>
      <a-input-password size="large" v-decorator="decorator.password" type="password" autocomplete="new-password" :placeholder="$t('validator.password')">
        <a-icon slot="prefix" type="lock" style="color: rgba(0, 0, 0, .25)" />
      </a-input-password>
    </a-form-item>
    <a-form-item>
      <a-row :gutter="24">
        <a-col :span="16">
          <a-checkbox v-decorator="decorator.isAgreement" @change="handleAgreementchange">
            <router-link target="_blank" :to="{ name: 'Agreement'}">{{$t('scope.user_agreement')}}</router-link>&
            <router-link target="_blank" :to="{ name: 'PrivacyPolicy'}">{{$t('scope.private_policy')}}</router-link>
          </a-checkbox>
        </a-col>
        <a-col :span="8">
          <p style="text-align: right"><router-link :to="{ name: 'Login'}">{{$t('scope.text_329')}}</router-link></p>
        </a-col>
      </a-row>
    </a-form-item>
    <a-form-item>
      <a-button size="large" type="primary" html-type="submit" :loading="loading" block :disabled="disabled">{{$t('scope.text_330')}}</a-button>
    </a-form-item>
  </a-form>
</template>

<script>
import WindowsMixin from '@/mixins/windows'

export default {
  name: 'RegisterByMobile',
  mixins: [WindowsMixin],
  data () {
    return {
      loading: false,
      enableSendSmsCode: false,
      startCountDown: false,
      count: 60,
      timer: null,
      disabled: true,
      form: {
        fc: this.$form.createForm(this),
      },
      decorator: {
        password: [
          'password',
          {
            validateFirst: true,
            validateTrigger: ['blur'],
            rules: [
              { required: false, message: this.$t('scope.text_333') },
              { validator: this.$validate('password') },
            ],
          },
        ],
        mobile: [
          'mobile',
          {
            validateFirst: true,
            validateTrigger: ['blur'],
            rules: [
              { required: true, message: this.$t('scope.text_351') },
              { validator: this.checkPhone },
            ],
          },
        ],
        random_code: [
          'random_code',
          {
            validateTrigger: ['blur'],
            rules: [
              { required: true, message: this.$t('scope.text_337') },
            ],
          },
        ],
        isAgreement: [
          'isAgreement',
          {
            initialValue: false,
          },
        ],
      },
      isAgreement: false,
    }
  },
  watch: {
    startCountDown (val) {
      if (val) {
        this.clearTimer()
        this.timer = setInterval(() => {
          if (this.count !== 0) {
            this.count--
          } else {
            this.enableSendSmsCode = false
            this.startCountDown = false
          }
        }, 1000)
      }
    },
  },
  destroyed () {
    this.clearTimer()
  },
  methods: {
    clearTimer () {
      clearInterval(this.timer)
      this.timer = null
    },
    handleAgreementchange (e) {
      this.disabled = !e.target.checked
    },
    checkPhone (rule, value, callback) {
      this.$validate('phone')
      const reg = /^1[0-9-]{10}$/
      if (reg.test(value)) {
        this.enableSendSmsCode = false
        callback()
      } else {
        this.enableSendSmsCode = true
        callback(this.$t('validator.phone'))
      }
    },
    getWebSmsCode () {
      const mobile = this.form.fc.getFieldValue('mobile')
      if (!mobile) {
        this.$message.warn(this.$t('scope.text_343'))
        return
      }
      this.createDialog('WebSmsCodeDialog', {
        mobile,
        success: () => {
          this.enableSendSmsCode = true
          this.startCountDown = true
        },
      })
    },
    registering () {
      this.loading = true
      this.$emit('register', this.loading)
    },
    registered () {
      this.loading = false
      this.$emit('register', this.loading)
    },
    handleSubmit (e) {
      e.preventDefault()
      this.form.fc.validateFields(async (err, values) => {
        if (err) return
        this.registering()
        try {
          Reflect.deleteProperty(values, 'isAgreement')
          const { invite } = this.$route.query
          if (invite) values.invite = invite
          values.method = 'mobile'
          await this.$http.post('/v2/register/customers', values)
          this.$router.push({
            path: 'registerresult',
            query: {
              ...this.$route.query,
              user_name: values.mobile,
            },
          })
        } catch {
          this.registered()
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
h4 {
  margin-top: 20px;
  margin-bottom: 40px;
}
.register-body {
  width: 570px;
  height: 680px;
  position: relative;
  background-color: #fff;
  padding: 40px;
  ::v-deep {
    .ant-input-group-addon {
      border: 0;
    }
  }
}
</style>
